module.exports = __webpack_public_path__ + "static/images/circle-green-check.2Za95Dm.svg";